interface VacancyDeltaProps {
  eventType: "appeared" | "disappeared";
  showLabel?: boolean;
}

export function VacancyDelta({ eventType, showLabel }: VacancyDeltaProps) {
  const label = showLabel ? "空室" : "";
  if (eventType === "appeared") {
    return <span className="text-blue-600 font-semibold">{label}+1</span>;
  }
  return <span className="text-danger font-semibold">{label}-1</span>;
}
